<script>
    export let isPositionBottom = false;
</script>

<div
    class="pointer-events-none absolute inset-0 mx-auto flex h-full w-full justify-center overflow-hidden text-center text-[8px] font-bold uppercase text-white tablet:text-xs"
    class:items-end={isPositionBottom}
>
    <div class="max-bet h-1/6 w-6/12" class:rounded-b-full={!isPositionBottom} class:rounded-t-full={isPositionBottom}>
        Max bet
    </div>
</div>

<style>
    .max-bet {
        background: linear-gradient(0deg, #fa460d 52.38%, #802200 100%);
    }
</style>
